import type { Property } from '~/core/entities/property';
import type { RealEstateListing, WithContext } from 'schema-dts';

import { PropertyJsonLdPresenter } from '~/presenters/PropertyJsonLdPresenter';
import { joinURL } from 'ufo';

export function usePropertiesListingJsonLd(
	propertiesGetter: () => Property[],
	{
		pageTitle: pageTitleGetter,
		pageDescription: pageDescriptionGetter
	}: { pageTitle: () => string; pageDescription: () => string }
) {
	const websiteUrl = useRuntimeConfig().public.ORIGIN;
	const route = useRoute();

	const properties = computed<Property[]>(propertiesGetter);
	const pageTitle = computed<string>(pageTitleGetter);
	const pageDescription = computed<string>(pageDescriptionGetter);

	const realEstateListingJsonLd = computed<WithContext<RealEstateListing>>(
		() => {
			const propertyOffers = properties.value
				.map(property =>
					PropertyJsonLdPresenter.getPropertyOfferJsonLd(property, {
						websiteUrl
					})
				)
				.filter(offer => offer !== undefined);

			return {
				'@type': 'RealEstateListing',
				'@context': 'https://schema.org',
				url: joinURL(websiteUrl, route.fullPath),
				name: pageTitle.value,
				description: pageDescription.value,
				offers: {
					'@type': 'AggregateOffer',
					offers: propertyOffers
				}
			} satisfies WithContext<RealEstateListing>;
		}
	);

	useJsonld(() => realEstateListingJsonLd.value);
}
